import gql from 'graphql-tag'

export const zoomCallNotification = gql`
  subscription zoomCallNotification ($userId: Int!) {
    zoomCallNotification(userId: $userId) {
      event
      callee {
        id
        username
      }
      callerNumber
    }
  }
`
